import React, { Fragment, useEffect, useState } from "react";
import PageTitle from "../../../layouts/PageTitle";
import axios from '../../../../services/AxiosInstance';
//import axios from 'axios';

import swal from "sweetalert";
import ClientList from "./ClientList";
const ClientMaster = () => {
   const [client,setClientMaster] = useState([]);
   function  getClientMasterData(){
      axios.get(`/api/auth/client-details`)
      .then((res) => {
         console.log("Client List");
         console.log(res.data.client);
         setClientMaster(res.data.client);
      })
      .catch((error) => {
         swal("Please try again",error.message, "error");
      })
    }
    useEffect(()=>{
      getClientMasterData();
    },['']);
    const DataTable = () => {
      return client.map((res, i) => {
        return <ClientList obj={res} key={i} />;
      });
    };
   
    return (
      <Fragment>
         <PageTitle activeMenu="Client Master" motherMenu="Users" />
         <div className="row">
            <div className="col-lg-12">
               <div className="card">
                  <div className="card-body">
                    {/* <Link className="btn btn-primary font-w600 mb-2 me-auto" to={"/add-company"}>+ Add Company</Link> */}
                     <div className="table-responsive" style={{minHeight:"200px"}}>
                        <table className="primary-table-bordered table">
                           <thead className="thead-primary">
                              <tr>
                                 {/* <th>ID</th> */}
                                 <th>Name</th>
                                 <th>Email</th>
                                 <th>Watsapp No</th>
                                 <th>Alternate No</th>
                                 {/* <th>Booking Desk</th>
                                 <th>About US</th> */}
                                 <th>GST No</th>
                                 <th>Domain Name</th>
                                 <th>Bank Name</th>
                                 <th>Branch Name</th>
                                 <th>Account No</th>
                                 <th>IFSC Code</th>
                              </tr>
                           </thead>
                           <tbody>
                           {DataTable()}
                           </tbody>
                        </table>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </Fragment>
   );
}
export default ClientMaster;